import { useLang } from "@/context/LangContext";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { Languages, Check } from "lucide-react";

export default function LanguageSwitcher({ variant = "ghost", className = "" }) {
  const { lang, setLang, languages } = useLang();
  const current = languages.find((l) => l.code === lang) || languages[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button data-testid="lang-switcher" variant={variant} size="sm" className={`gap-1.5 rounded-full ${className}`}>
          <Languages className="w-4 h-4" />
          <span className="text-xs font-semibold">{current.label}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[160px]">
        {languages.map((l) => (
          <DropdownMenuItem key={l.code} data-testid={`lang-${l.code}`} onClick={() => setLang(l.code)}
            className="flex items-center justify-between cursor-pointer" dir={l.dir}>
            <span>{l.label}</span>
            {l.code === lang && <Check className="w-4 h-4 text-brand" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
